import { Box, PageLayout } from '@primer/react';
import React, { createContext, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Header from './header';
import Menu from './menu';
export interface ILayoutContext {
    isHideSubNav?: boolean,
    setHideSubNav?: (isHidden: boolean) => void
}
export const LayoutContext = createContext<ILayoutContext>({
    isHideSubNav: false
});
interface ILayoutProps {
    children?: React.ReactNode;
}

const Layout = (props: ILayoutProps) => {
    const location = useLocation(); // Sử dụng useLocation để lấy đường dẫn
    const currentUrl = location.pathname; // Sử dụng pathname thay vì window.location.href
    const [isHideSubNav, setIsHideSubNav] = useState(false);

    const contextValue: ILayoutContext = {
        isHideSubNav,
        setHideSubNav: setIsHideSubNav
    }

    return (
        <LayoutContext.Provider value={contextValue}>
            <PageLayout containerWidth="full" sx={{ padding: 0 }}>
                <>
                    {!currentUrl.includes("crm_survey_register") && (
                        <PageLayout.Header sx={{ marginBottom: 0 }}>
                            <Header />
                        </PageLayout.Header>
                    )}
                    {isHideSubNav !== true &&
                        <PageLayout.Pane
                            sx={{
                                maxWidth: "200px",
                                width: "200px",
                                marginRight: "0px!important",
                            }}
                            position={'start'}
                        >
                            <Box
                                height={window.innerHeight - 90}
                                overflow={"auto"}
                                sx={{
                                    borderRightWidth: "1px",
                                    borderRightStyle: "solid",
                                    borderRightColor: "border.default",
                                    m: 0
                                }}
                            >
                                <Menu />
                            </Box>
                        </PageLayout.Pane>
                    }
                    <PageLayout.Content sx={{ p: 0 }}>
                        <Box height={window.innerHeight - 90} overflow={"auto"}>
                            {props.children}
                        </Box>
                    </PageLayout.Content>
                </>
            </PageLayout>
        </LayoutContext.Provider>
    );
};

export default Layout;
